(() => {
  function init(root) {
    if (root.dataset.discoverReady) return;
    const track = root.querySelector('[data-discover-track]');
    if (!track) return;
    root.dataset.discoverReady = 'true';

    const previous = root.querySelector('[data-discover-previous]');
    const next = root.querySelector('[data-discover-next]');
    const cards = [...track.querySelectorAll('.discover-topics__card')];
    const updateArrows = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.hidden = track.scrollLeft < 2;
      next.hidden = track.scrollLeft >= max - 2;
    };
    const move = (direction) => {
      const current = cards.findIndex((card) => card.offsetLeft > track.scrollLeft + track.offsetLeft + 4);
      const target = direction > 0
        ? cards[Math.max(0, current)]
        : [...cards].reverse().find((card) => card.offsetLeft < track.scrollLeft + track.offsetLeft - 4);
      if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateArrows, { passive: true });
    track.addEventListener('dragstart', (event) => event.preventDefault());
    const resizeObserver = new ResizeObserver(updateArrows);
    resizeObserver.observe(track);
    root.discoverCleanup = () => resizeObserver.disconnect();

    let origin = null;
    let dragged = false;
    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      origin = { x: event.clientX, scroll: track.scrollLeft };
      dragged = false;
    });
    track.addEventListener('pointermove', (event) => {
      if (!origin) return;
      const delta = event.clientX - origin.x;
      if (Math.abs(delta) > 5) {
        dragged = true;
        track.classList.add('is-dragging');
        if (!track.hasPointerCapture(event.pointerId)) track.setPointerCapture(event.pointerId);
        track.scrollLeft = origin.scroll - delta;
        event.preventDefault();
      }
    });
    const endDrag = () => {
      origin = null;
      track.classList.remove('is-dragging');
      if (dragged) {
        const nearest = cards.reduce((best, card) => {
          const distance = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
          return distance < best.distance ? { card, distance } : best;
        }, { card: cards[0], distance: Infinity }).card;
        if (nearest) track.scrollTo({ left: nearest.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', (event) => {
      if (dragged) {
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }
    }, true);
    updateArrows();
  }

  document.querySelectorAll('[data-discover-topics]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-discover-topics]').forEach(init);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-discover-topics]').forEach((root) => root.discoverCleanup?.());
  });
})();
